// src/composables/useSesion.js
import { useRouter } from 'vue-router'
import axios from 'axios'

export function useSesion() {
  const router = useRouter()

  /**
   * Verifica si la sesión sigue activa.
   * @param {boolean} actualizar - Si true, también actualiza la última actividad.
   * @returns {Promise<boolean>} true si la sesión es válida, false si ha expirado.
   */
  const verificarSesion = async (actualizar = false) => {
    try {
      const token = JSON.parse(localStorage.getItem("user_acces"))?.token
      const proyecto = JSON.parse(localStorage.getItem("user_acces"))?.proyecto
    //   const token = localStorage.getItem('token')

      if (!token) {
        console.warn('No hay token en localStorage')
        return false
      }

      const response = await axios({
        method: actualizar ? 'POST' : 'GET',
        url: 'https://aerovichada.com.co/AEROV/verificar_sesion.php',
        headers: {
          Authorization: `Bearer ${token}`
        },
        ...(actualizar
          ? {
              data: {
                actualizar: true,
                proyecto: proyecto // 👈 se envía como parte del cuerpo en POST
              }
            }
          : {
              params: {
                proyecto: proyecto // 👈 se envía como parámetro en GET
              }
            })
      });

      // const response = await axios({
      //   method: actualizar ? 'POST' : 'GET',
      //   url: 'https://aerovichada.com.co/AEROV/verificar_sesion.php',
      //   headers: {
      //     Authorization: `Bearer ${token}`
      //   },
      //   data: actualizar ? { actualizar: true } : null
      // })

      const data = response.data

      if (data.valido) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Error al verificar sesión:', error)
      return false
    }
  }

  /**
   * Inicia una verificación automática cada X minutos.
   * Si la sesión expira, redirige al login.
   * @param {number} intervaloMinutos - Cada cuántos minutos verificar (ej: 10).
   */
  const iniciarVerificador = (intervaloMinutos = 10) => {
    const milisegundos = intervaloMinutos * 60 * 1000

    const verificar = async () => {
      const valido = await verificarSesion(false)
      if (!valido) {
        localStorage.removeItem('token')
        alert('Tu sesión ha expirado por inactividad.')
        router.push('/')
      }
    }

    // Ejecutar una vez al iniciar
    verificar()

    // Ejecutar periódicamente
    setInterval(verificar, milisegundos)
  }

  return {
    verificarSesion,
    iniciarVerificador
  }
}
